import {
  createCase,
  updateCaseById,
} from "@customer-experience/freem-lead-client";
import axiosInstance from "./axiosInstance";

async function sendConfirmationEmails({
  firstName,
  lastName,
  email,
  telephone,
  hasRSV,
  extraNotes,
  leadLink,
  violationType,
  letterType,
  source,
}) {
  const response = await axiosInstance.post(
    "https://chevalier.group/webhook/trigger/6061d0ae913c0d001af422be",
    {
      firstName,
      lastName,
      email,
      telephone,
      hasRSV,
      extraNotes,
      leadLink,
      violationType,
      letterType,
      source,
    }
  );

  return response.data;
}

export {
  createCase,
  updateCaseById,
  sendConfirmationEmails,
};
